import { fallbackQuestions, fallbackReport } from "../shared/fallback-coach";
import type { AnalyzeRequest, DecisionReport, QuestionRequest, QuestionResponse, ShareSnapshot } from "../shared/types";
import { redactPrivateAnswers } from "../shared/share";

async function requestJson<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    ...init,
    headers: { "content-type": "application/json", ...(init?.headers ?? {}) },
  });
  const body = await response.json() as T & { error?: string };
  if (!response.ok) throw new Error(body.error ?? "暫時無法連接");
  return body;
}

export async function askQuestions(input: QuestionRequest): Promise<QuestionResponse> {
  try {
    return await requestJson<QuestionResponse>("/api/questions", { method: "POST", body: JSON.stringify(input) });
  } catch (error) {
    if (error instanceof Error && /太頻繁|多说|多說|描述/.test(error.message)) throw error;
    return fallbackQuestions(input.decision, input.locale);
  }
}

export async function analyzeDecision(input: AnalyzeRequest): Promise<DecisionReport> {
  try {
    return await requestJson<DecisionReport>("/api/analyze", { method: "POST", body: JSON.stringify(input) });
  } catch (error) {
    if (error instanceof Error && /太頻繁|回答/.test(error.message)) throw error;
    return fallbackReport(input);
  }
}

export function createShare(report: DecisionReport, privateAnswers: string[]): Promise<{ id: string; url: string; expiresAt: string }> {
  const publicReport = redactPrivateAnswers(report, privateAnswers);
  return requestJson("/api/share", { method: "POST", body: JSON.stringify({ report: publicReport }) });
}

export function getShare(id: string): Promise<ShareSnapshot> {
  return requestJson(`/api/share/${id}`);
}
